import React from 'react';

const ConsultantPortal = () => {
  return (
    <div className="consultant-portal">
      <div className="page-header">
        <h2>Danışman Portalı</h2>
        <p>Danışman işlemlerini yönetin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default ConsultantPortal; 